import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tabs } from "antd";
import PolicySubjectTabDetails from "./PolicySubjectTabDetails/PolicySubjectTabDetails";
import { TabsWrapper } from "../../../../../Commons/Wrappers";
import PolicySubjectTabHistory from "./PolicySubjectTabHistory/PolicySubjectTabHistory";

interface IPolicySubjectTabsProps {
  defaultTab?: string;
}

const PolicySubjectTabs = ({ defaultTab }: IPolicySubjectTabsProps) => {
  const { t } = useTranslation();

  const [keyActive, setKeyActive] = useState("details");

  const handleOnChangeTab = (key: string) => {
    setKeyActive(key);
  };

  return (
    <TabsWrapper>
      <Tabs
        items={[
          {
            key: "details",
            label: t("TABS.subject-details"),
            children: <PolicySubjectTabDetails />,
          },
          {
            key: "history",
            label: t("TABS.subject-history"),
            children: <PolicySubjectTabHistory />,
            
          },
        ]}
        tabPosition="left"
        onChange={handleOnChangeTab}
        destroyOnHidden={true}
        defaultActiveKey={defaultTab || keyActive}
      />
    </TabsWrapper>
  );
};

export default PolicySubjectTabs;
